import { Link } from 'react-router';
import { PageHeader } from '../components/ui';

export function NotFound() {
  return (
    <div>
      <PageHeader title="Page not found" />
      <Link to="/" className="text-indigo-600 hover:underline">Back to Home</Link>
    </div>
  );
}
